/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API38465Item {
  
  /** 业务id */
  cloudCategoryId?: string;
  
  /** 业务平台名称 */
  cloudCategoryName?: string;
  
  /** 云描述 */
  cloudCategoryRemark?: string;
  
  /**  */
  icon?: string;
  
};
    
  



  export type API38465Req = {};



export interface API38465Res {
  /** T  */
  list?: API38465Item[];
  
};


// 38465 获取有权限的云分类列表

export interface IUseGetAPI38465Return {
  /** 获取有权限的云分类列表: 接口请求状态 */
  isAPI38465Loading: boolean;
  /** 获取有权限的云分类列表: 接口请求返回数据 */
  dataAPI38465: API38465Res;
  /**  获取有权限的云分类列表: 接口数据请求方法 */
  fetchAPI38465Data:  ( config?: YWRequestConfig) => Promise<API38465Res>;
  /** 获取有权限的云分类列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI38465 = ():IUseGetAPI38465Return => {
  let isMount = true;
  const [isAPI38465Loading, setIsAPI38465Loading] = useState(false);
  const [dataAPI38465, setDataAPI38465] = useState<API38465Res>({} as API38465Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/resource/list/categories`;

  const fetchAPI38465Data = async ( config?: YWRequestConfig): Promise<API38465Res> => {
  
    if ( isMount ) {
      setIsAPI38465Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API38465Res>(`${basePath}/ywwl-admin/desktop/resource/list/categories`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI38465(res || {} as API38465Res);
        setIsAPI38465Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI38465Loading(false);
      }
      return false as unknown as API38465Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI38465Loading,
    dataAPI38465,
    fetchAPI38465Data,
    requestUrl,
  }
}

